import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { usePageSEO } from "@/hooks/use-seo";

const NotFound = () => {
  const location = useLocation();

  usePageSEO(
    "Page Not Found - Zoocertica",
    "The page you're looking for doesn't exist. Return to Zoocertica's wildlife management platform."
  );

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="text-center max-w-md w-full">
        <h1 className="text-3xl sm:text-4xl font-bold mb-4 text-foreground">404</h1>
        <p className="text-lg sm:text-xl text-muted-foreground mb-6 px-2">Oops! Page not found</p>
        <Link 
          to="/" 
          className="inline-flex items-center justify-center rounded-md bg-primary px-6 py-3 text-sm font-medium text-primary-foreground shadow transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50"
        >
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
